import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, AwaitModules, Button_VersionUpdate, ComponentSync, Dialog_IDBCacheComparison, Dialog_SyncEnvFromProd, LL_H_C, ModuleFE_Dialog, ModuleFE_Notifications, ModuleFE_RoutingV2, ModuleFE_StorageCleaner, ModuleFE_SyncEnvV2, Thunder } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import { ModuleFE_Discussion } from '@app/hcs-frontend';
import { Component_AccountThumbnail, ModuleFE_Account, PopUp_AccountMenu } from '@nu-art/user-account-frontend/index';
import { AccessLevel, ModuleFE_PermissionsAssert } from '@nu-art/permissions-frontend/modules/ModuleFE_PermissionsAssert';
import { PermissionKeyFE_DeveloperViewer } from '@nu-art/permissions-frontend/core/permission-keys';
import { ModuleFE_Artifact, ModuleFE_User } from '@app/org-frontend';
import './Component_Header.scss';
import { ModuleFE_AppModule, RouteDomainsMap } from '../../../modules/app-module/ModuleFE_AppModule.js';
import { Component_DiscussionButton } from './Component_DiscussionsButton/Component_DiscussionButton.js';
import { Component_UserDetailsEditor } from './Component_UserDetailsEditor/Component_UserDetailsEditor.js';
import { Component_GlobalSearch } from '../search/Component_GlobalSearch/Component_GlobalSearch.js';
import { Component_AddEntity } from './Component_AddEntity/Component_AddEntity.js';
import { Dialog_VolatileImport } from '@app/data-migration-frontend';
import { openContent } from '@nu-art/thunderstorm-frontend';
export class Component_Header extends ComponentSync {
    // ######################### Life Cycle #########################
    __onDiscussionsUpdated(...params) {
        this.reDeriveState();
    }
    __onLocationChanged(path) {
        this.reDeriveState();
    }
    __onToggleSideNavBarState() {
        this.forceUpdate();
    }
    __onUsersUpdated = (...params) => {
        this.forceUpdate();
    };
    deriveStateFromProps(nextProps) {
        return {
            routeKey: ModuleFE_RoutingV2.getCurrentRouteKey()?.key,
        };
    }
    // ######################### Logic #########################
    discussionsButton() {
        return _jsx(AwaitModules, { modules: [ModuleFE_Discussion], customMissingPermissionsRenderer: () => _jsx(_Fragment, {}), children: _jsx(Component_DiscussionButton, {}) });
    }
    getEnvString() {
        switch (ModuleFE_AppModule.getEnv()?.toLowerCase()) {
            case 'local':
                return 'local';
            case 'dev':
                return 'dev';
            case 'staging':
                return 'staging';
            default:
                return '';
        }
    }
    openAccountMenu = (e) => {
        const user = ModuleFE_User.getUser();
        const menuActions = [
            PopUp_AccountMenu.Action_EditPassword,
            {
                label: 'IDB-Cache Comp',
                type: 'action',
                closePopUp: true,
                action: () => Dialog_IDBCacheComparison.show(),
            },
            {
                label: 'Sync DB from Prod',
                type: 'action',
                closePopUp: true,
                disabled: ModuleFE_SyncEnvV2.isProd(),
                action: async (e) => {
                    if (e.shiftKey) {
                        Dialog_SyncEnvFromProd.show();
                        return;
                    }
                    await ModuleFE_SyncEnvV2.runOneClickFromProd();
                },
            },
            {
                label: 'Edit My Details',
                type: 'page',
                pageKey: 'edit-my-details',
                content: (account, trigger) => _jsx(Component_UserDetailsEditor, { account: account, onSubmitCompleted: trigger })
            },
        ];
        if (ModuleFE_PermissionsAssert.getAccessLevel(PermissionKeyFE_DeveloperViewer) === AccessLevel.HasAccess)
            menuActions.push(PopUp_AccountMenu.Action_AppToolsButton('/app-tools'));
        if (ModuleFE_PermissionsAssert.getAccessLevel(ModuleFE_AppModule.permissions.ui.Allowed) === AccessLevel.HasAccess)
            menuActions.push({
                label: 'Create Artifact',
                // className: 'create-artifact-button',
                id: 'create-artifact-button',
                type: 'action',
                closePopUp: false,
                action: async () => {
                    const buttonElement = document.getElementById('create-artifact-button');
                    try {
                        const env = Thunder.getInstance().getConfig().label?.toLowerCase() === 'local' ? 'local' : Thunder.getInstance().getConfig().label?.toLowerCase();
                        //Not awaiting in purpose.
                        ModuleFE_Artifact._v1['trigger-artifact-pipeline']({
                            fromEnv: env,
                            toEnv: env,
                        }).setOnCompleted(async (response) => {
                            buttonElement.classList.remove('create-artifact-button-disabled');
                            buttonElement.classList.add('create-artifact-button-enabled');
                            ModuleFE_Dialog.show({
                                content: _jsx("div", { className: 'pop-up_trigger-artifact', children: `Artifact creation ${response.triggered ? 'triggered' : 'failed triggering'}.` }),
                                closeOverlayOnClick: () => true,
                                dialogKey: 'artifact-trigger-message'
                            });
                        }).setOnError(async (errorResponse) => {
                            buttonElement.classList.remove('create-artifact-button-disabled');
                            buttonElement.classList.add('create-artifact-button-enabled');
                            ModuleFE_Dialog.show({
                                content: _jsx("div", { className: 'pop-up_trigger-artifact', children: `Artifact creation failed triggering.` }),
                                closeOverlayOnClick: () => true,
                                dialogKey: 'artifact-trigger-message'
                            });
                        }).executeSync();
                    }
                    finally {
                        buttonElement.classList.remove('create-artifact-button-enabled');
                        buttonElement.classList.add('create-artifact-button-disabled');
                    }
                }
            });
        PopUp_AccountMenu.show(e, {
            accountId: user._id,
            accountDisplayModifier: (account) => {
                const user = ModuleFE_User.cache.unique(account._id);
                if (!user)
                    return;
                let str = '';
                str += user.title ?? '';
                str += ` ${user.firstName ?? ''}`;
                str += ` ${user.surname ?? ''}`;
                return str.trim() || undefined;
            },
            acronymComposer: this.userAcronymComposer,
            menuActions: menuActions
        }, { offset: { y: 20, x: 15 } });
    };
    userAcronymComposer = (accountId) => {
        const user = ModuleFE_User.cache.unique(accountId);
        if (!user || (!user.firstName || !user.surname))
            return;
        return user.firstName.charAt(0) + user.surname.charAt(0);
    };
    // ######################### Render #########################
    render() {
        const user = ModuleFE_User.getUser();
        const pageTitle = RouteDomainsMap[this.state.routeKey]?.routeTitle;
        return (_jsxs("div", { className: _className('knowledge-manager__header ll_h_c match_width', this.getEnvString()), children: [_jsxs(LL_H_C, { className: 'header__left-container flex__grow', children: [_jsx(ICONS.sidebarMaximize.component, { className: _className('header__side-nav-bar__open-icon', ModuleFE_AppModule.getNavBarStatus() ? 'open' : undefined), onClick: (e) => {
                                ModuleFE_AppModule.toggleSideNavBar();
                            } }), _jsxs("span", { className: 'header__left-container__title', children: ["KNOWLEDGE MANAGER", pageTitle && _jsxs(_Fragment, { children: [" - ", _jsx("b", { children: pageTitle })] })] })] }), _jsx(Component_GlobalSearch, {}), _jsxs(LL_H_C, { className: 'header__right-container flex__grow', children: [_jsx(Button_VersionUpdate, { updateVersion: async () => {
                                await ModuleFE_Account.logout();
                                window.location.reload();
                                await ModuleFE_StorageCleaner.cleanAll();
                            } }), _jsx(Component_AddEntity, {}), _jsx(ICONS.upload.component, { className: 'c__import-csv', ...openContent.tooltip.bottom('tooltip__import-csv', 'Import CSV', { offset: 8 }), onClick: () => Dialog_VolatileImport.show() }), _jsx(ICONS.advisor_avn_bell.component, { className: 'notifications-button', onClick: () => ModuleFE_Notifications.showAllNotifications() }), this.discussionsButton(), user && _jsx(Component_AccountThumbnail, { accountId: () => user._id, onClick: this.openAccountMenu, acronymComposer: this.userAcronymComposer, modulesToAwait: [ModuleFE_User] }), _jsx(ICONS.quai.component, { className: 'header__logo' })] })] }));
    }
}
